import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {EventWebservice} from "../../../services/webservices/event.webservice";
import {Observable} from "rxjs";
import {Event} from "../../../model/event/event.model";

export const eventDetailResolver: ResolveFn<Event> = (route, state): Observable<Event> => {
  const eventWebservice = inject(EventWebservice);
  return eventWebservice.getEventById(route.params['id']);
};
